import { render, staticRenderFns } from "./ViewSync.vue?vue&type=template&id=3be4353a&scoped=true"
import script from "./ViewSync.vue?vue&type=script&lang=js"
export * from "./ViewSync.vue?vue&type=script&lang=js"
import style0 from "./ViewSync.vue?vue&type=style&index=0&id=3be4353a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4353a",
  null
  
)

export default component.exports